import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { ICreateExamPaperRequest, IExamPaper } from "./types";
import type { IApiResponse } from "../client";

export const createExamPaper = async (
  data: ICreateExamPaperRequest
): Promise<IExamPaper> => {
  const response = await apiPost<IExamPaper>("/exam_papers", data);
  if (!response.data) {
    throw new Error("Failed to create exam paper");
  }
  return response.data;
};

export const useCreateExamPaper = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createExamPaper,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.examPaper.all });
    },
  });
};
